import { setStoreConfiguration } from '@/redux/app-slice';
import { put, takeEvery, call, select } from 'redux-saga/effects';
import { AxiosResponse, isAxiosError } from 'axios';
import fflSelectInterface from '@/model/ffl-select.mjs';
import {
  defaultExportFFLLiveStoreusersModel,
  setGetFFLExportLiveStoreusers,
  setIsExportFFLLiveUserClicked,
  setIsGettingAdminConfig,
  setIsManualReviewEmailSendLoading,
  setIsReviewEmailTemplateLoading,
  setIsUpdatingSelectConfiguration,
  setLOAReviewDetails,
  setLOAReviewDetailsLoading,
  setLicenseReviewDetails,
  setLicenseReviewDetailsLoading,
  setReviewEmailTemplate,
  setSOTReviewDetails,
  setSOTReviewDetailsLoading,
  setfflSelectConfig
} from './slice';
import {
  getFFLSelectConfiguration,
  getLicenseReviewDetailsById,
  getLOAReviewDetailsById,
  getReviewEmailTemaplete,
  getSOTReviewDetailsById,
  sendReviewEmailTemaplete,
  updateSelectConfigurationApi,
  getFFLExportLiveUserStatus
} from '@/api/apis';
import { ToasterNotification } from '@/toaster/toasterNotification';
import { GlobalConfig } from '../types';
import { PayloadAction } from '@reduxjs/toolkit';
import { ExportFFLLiveUserEnum } from '@/utils/constants';
import { v4 as uuidv4 } from "uuid";

function* getFFLExportLiveStoreFilePath(){
  try{
    let pollCount = 1;
    const uuid = uuidv4();
    while (pollCount > 0) {
      const response: AxiosResponse<any> = yield call(
        getFFLExportLiveUserStatus,
        uuid
      );
      
      if (response?.status === 200) {
        const data = response.data || {};
        yield put(setGetFFLExportLiveStoreusers(data));
        
        // If completed, stop polling
        if (data.status === ExportFFLLiveUserEnum.completed) {
          yield put(setIsExportFFLLiveUserClicked(false));
          pollCount = 0;
          break;
        }
        // If pending, wait and continue
        if (data.status === ExportFFLLiveUserEnum.pending) {
          pollCount++;
        }
      } else {
        break; // API error, stop polling
      }
    }
  }
  catch (error) {
    console.log('error', error);
    yield put(setGetFFLExportLiveStoreusers(defaultExportFFLLiveStoreusersModel));
    yield put(setIsExportFFLLiveUserClicked(false)); // Error me state reset karo
  } 
}

function* getFFLSelectConfig() {
  try {
    yield put(setIsGettingAdminConfig(true));
    const response: AxiosResponse<fflSelectInterface> = yield call(
      getFFLSelectConfiguration
    );
    yield put(setfflSelectConfig(response.data || {}));
  } catch (error) {
    console.log('error', error);
  } finally {
    yield put(setIsGettingAdminConfig(false));
  }
}

function* updateFFLSelectConfig(action: PayloadAction<GlobalConfig>) {
  try {
    yield put(setIsUpdatingSelectConfiguration(true));
    const response: AxiosResponse<fflSelectInterface> = yield call(
      updateSelectConfigurationApi,
      action.payload
    );
    if (response?.status === 200) {
      yield put(setfflSelectConfig(response.data || {}));
      ToasterNotification('success', 'Configuration updated successfully');
    }
  } catch (error) {
    console.log('error', error);
    ToasterNotification('error', 'Configuration updated failed');
  } finally {
    yield put(setIsUpdatingSelectConfiguration(false));
  }
}

function* onGetEmailTemplate(action: PayloadAction<any>) {
  try {
    yield put(setIsReviewEmailTemplateLoading(true));
    const response: AxiosResponse<any> = yield call(
      getReviewEmailTemaplete,
      action.payload
    );
    if (response?.status === 200) {
      yield put(setReviewEmailTemplate(response.data || {}));
    }
  } catch (error) {
    console.log('error', error);
    yield put(setIsReviewEmailTemplateLoading(false));
  } finally {
    yield put(setIsReviewEmailTemplateLoading(false));
  }
}

function* onSendEmailTemplate(action: PayloadAction<any>) {
  try {
    yield put(setIsManualReviewEmailSendLoading(true));
    const response: AxiosResponse<any> = yield call(
      sendReviewEmailTemaplete,
      action.payload
    );
    if (response?.status === 200) {
      yield put(setIsManualReviewEmailSendLoading(false));
    }
  } catch (error) {
    console.log('error', error);
    yield put(setIsManualReviewEmailSendLoading(false));
  } finally {
    yield put(setIsManualReviewEmailSendLoading(false));
  }
}

function* onGetLicenseReviewDetails(action: PayloadAction<any>) {
  try {
    yield put(setLicenseReviewDetailsLoading(true));
    const response: AxiosResponse<any> = yield call(
      getLicenseReviewDetailsById,
      action.payload
    );
    
    
    if (response?.status === 200 && response.data.items.length > 0) {
      const licenseReview = response.data.items[0];
      yield put(setLicenseReviewDetails(licenseReview || {}));
      yield put(setLicenseReviewDetailsLoading(false));


    }
  } catch (error) {
    console.log('error', error);
    yield put(setLicenseReviewDetailsLoading(false));
  } finally {
    yield put(setLicenseReviewDetailsLoading(false));
  }
}

function* onGetSOTReviewDetails(action: PayloadAction<any>) {
  try {
    yield put(setLicenseReviewDetailsLoading(true));
    const response: AxiosResponse<any> = yield call(
      getSOTReviewDetailsById,
      action.payload
    );
    if (response?.status === 200 && response.data.items.length > 0) {
      const SOTReview = response.data.items[0];
      yield put(setSOTReviewDetails(SOTReview || {}));
      yield put(setSOTReviewDetailsLoading(false));
    }
  } catch (error) {
    console.log('error', error);
    yield put(setSOTReviewDetailsLoading(false));
  } finally {
    yield put(setSOTReviewDetailsLoading(false));
  }
}

function* onGetLOAReviewDetails(action: PayloadAction<any>) {
  try {
    yield put(setLOAReviewDetailsLoading(true));
    const response: AxiosResponse<any> = yield call(
      getLOAReviewDetailsById,
      action.payload
    );
    if (response?.status === 200 && response.data.items.length > 0) {
      const LOAReview = response.data.items[0];
      yield put(setLOAReviewDetails(LOAReview || {}));
      yield put(setLOAReviewDetailsLoading(false));
    }
  } catch (error) {
    console.log('error', error);
    yield put(setLOAReviewDetailsLoading(false));
  } finally {
    yield put(setLOAReviewDetailsLoading(false));
  }
}

function* watchCallToGetFFLSelectConfig() {
  yield takeEvery('admin/callToGetFFLSelectConfig', getFFLSelectConfig);
}

function* watchCallTogetFFLExportLiveStoreFilePath() {
  yield takeEvery('admin/callToGetExportFFLLiveUsers', getFFLExportLiveStoreFilePath);
}

function* watchToCallToUpdateSelectConfiguration() {
  yield takeEvery(
    'admin/callToUpdateSelectConfiguration',
    updateFFLSelectConfig
  );
}
function* watchCallToGetReviewEmailTemplate() {
  yield takeEvery('admin/callToGetReviewEmailTemplate', onGetEmailTemplate);
}

function* watchCallToSendEmailTemplate() {
  yield takeEvery('admin/callToSendReviewEmailTemplate',onSendEmailTemplate); 
}

function* watchCallToGetLicenseReviewDetails() {
  yield takeEvery('admin/callToGetLicenseReviewDetails', onGetLicenseReviewDetails);
}
function* watchCallToGetSOTReviewDetails() {
  yield takeEvery('admin/callToGetSOTReviewDetails', onGetSOTReviewDetails);
}
function* watchCallToGetLOAReviewDetails() {
  yield takeEvery('admin/callToGetLOAReviewDetails', onGetLOAReviewDetails);
}


export {
  watchCallToGetFFLSelectConfig,
  watchToCallToUpdateSelectConfiguration,
  watchCallToGetReviewEmailTemplate,
  watchCallToSendEmailTemplate,
  watchCallToGetLicenseReviewDetails,
  watchCallToGetSOTReviewDetails,
  watchCallToGetLOAReviewDetails,
  watchCallTogetFFLExportLiveStoreFilePath
};
